/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
import abbreviatedRelativeTime from 'embercom/lib/abbreviated-relative-time';

export default buildHelper(function (params) {
  return abbreviatedRelativeTime(params[0]);
});
